<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  identifier: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['unlinkIssue']);

const unlinkIssue = () => {
  emit('unlinkIssue');
};
</script>

<template>
  <div class="flex items-center justify-between">
    <div
      class="flex items-center gap-2 px-2 py-1.5 border rounded-lg border-n-strong"
    >
      <div class="flex items-center gap-1">
        <span class="text-xs font-medium text-n-slate-12">
          {{ identifier }}
        </span>
      </div>
    </div>

    <Button ghost xs slate icon="i-lucide-unlink" @click="unlinkIssue" />
  </div>
</template>
